// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck-content .text-tiny{\n  font-size:.7em\n}\n\n.ck-content .text-small{\n  font-size:.85em\n}\n\n.ck-content .text-big{\n  font-size:1.4em\n}\n\n.ck-content .text-huge{\n  font-size:1.8em\n}", ""]);
// Exports
module.exports = exports;
